import { Inject, Injectable } from '@angular/core';

import { I18nService } from '@personal-area/global/i18n';
import { UserFacade } from '@personal-area/global/users/services';
import { LOCATION } from '@personal-area/common';
import { TranslateService } from '@ngx-translate/core';
import { Observable, combineLatest, map, startWith } from 'rxjs';

import { environment } from '@env/environment';

const COUNTRIES_WITH_PREFIXES = ['BRA', 'IND', 'PAK', 'MMR', 'ZAF'];

@Injectable({
  providedIn: 'root',
})
export class DocumentLinksService {
  public customerAgreement$: Observable<string>;
  public partnerAgreement: string;
  public tradingConditions: string;
  public riskWarning$: Observable<string>;
  public amlPolicy$: Observable<string>;
  public privacyPolicy$: Observable<string>;

  constructor(
    translateService: TranslateService,
    i18nService: I18nService,
    userFacade: UserFacade,
    @Inject(LOCATION) location: Location,
  ) {
    const host = location.host;
    const docPrefix = environment.documentPrefixesByDomain?.[host]
      ? environment.documentPrefixesByDomain[host] + '_'
      : '';
    const docLanguageA2$ = translateService.onLangChange.pipe(
      startWith({ lang: environment.defaultLanguage }),
      map(({ lang }) =>
        host !== environment.rootDomain && i18nService.domainLanguageA2 !== lang
          ? environment.defaultLanguage.slice(0, 2)
          : i18nService.languageA2,
      ),
    );

    this.customerAgreement$ = combineLatest([
      userFacade.geoLocation$,
      docLanguageA2$,
    ]).pipe(
      map(([location, language]) => {
        const countryPrefix = COUNTRIES_WITH_PREFIXES.includes(location)
          ? `${location}_`
          : '';
        return `/docs/${docPrefix}${countryPrefix}FBS_agreement_${language}.pdf`;
      }),
    );
    this.partnerAgreement = `/docs/${docPrefix}Partner_Agreement_en.pdf`;
    this.tradingConditions = `/docs/${docPrefix}Trading_conditions_en.pdf`;
    this.riskWarning$ = docLanguageA2$.pipe(
      map((language) => `/docs/${docPrefix}risk_warning_${language}.pdf`),
    );
    this.amlPolicy$ = docLanguageA2$.pipe(
      map((language) => `/docs/${docPrefix}aml_policy_${language}.pdf`),
    );
    this.privacyPolicy$ = docLanguageA2$.pipe(
      map((language) => `/docs/${docPrefix}privacy_policy_${language}.pdf`),
    )
  }
}
